var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6163",
    d: "M521.365029,156 C521.641171,156 521.870838,156.189161 521.918466,156.438612 L521.927529,156.534731 L521.927,159.802 L525.470443,159.802529 C525.765766,159.802529 526.005173,160.054369 526.005173,160.365029 C526.005173,160.641171 525.816012,160.870838 525.566561,160.918466 L525.470443,160.927529 L521.927,160.927 L521.927529,164.465269 C521.927529,164.760593 521.675689,165 521.365029,165 C521.088886,165 520.859219,164.810839 520.811591,164.561388 L520.802529,164.465269 L520.802,160.927 L517.534731,160.927529 C517.239407,160.927529 517,160.675689 517,160.365029 C517,160.088886 517.189161,159.859219 517.438612,159.811591 L517.534731,159.802529 L520.802,159.802 L520.802529,156.534731 C520.802529,156.239407 521.054369,156 521.365029,156 Z",
    transform: "rotate(45 452.018 -543.281)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.4360b477.svg";
export { ForwardRef as ReactComponent };